import { AccountInfo, IPublicClientApplication } from '@azure/msal-browser';
import { loginRequest } from '../../authConfig';
import { getHeaders } from '../../helpers/getHeaders';
import { get } from '../../helpers/axiosWrapper';

export const getAdminFAQs = (
  account: AccountInfo,
  instance: IPublicClientApplication,
  params: Api.IAdminFAQGridParams,
  success: Function,
  error: Function
) => {
  const request = {
    ...loginRequest,
    account: account,
  };

  instance
    .acquireTokenSilent(request)
    .then(async (response: any) => {
      var headers = new Headers();
      var bearer = 'Bearer ' + response.idToken;
      headers.append('Authorization', bearer);
      var options = {
        method: 'GET',
        headers: headers,
      };

      const url = process.env.REACT_APP_API_SERVICES_URL;
      const currentAdminFaqEndpoint = `${url}/documentmanagement/getallfaqdetails`;

      headers.append('page', String(params.page));
      headers.append('pageSize', String(params.pageSize));
      headers.append('sortDir', params.sortDir);

      fetch(currentAdminFaqEndpoint, options)
        .then(response => {
          if (response.status === 200) {
            return response.json();
          }
        })
        .then((adminFaqDetailsResult: Common.IResult<Array<any>>) => {
          if (adminFaqDetailsResult && adminFaqDetailsResult.success) {
            adminFaqDetailsResult.data.map((row: any) => {
              row.idExt = `DOC-${row.id}`;
              row.statusExt = row.status;
              if (row.status === 'Ready') row.statusExt = 'Ready to publish';
              if (row.updatedDate === null && row.updatedBy === null) {
                row.updatedBy = row.createdBy;
              }
              row.id = row.faqId;
              row.faqId = `FAQ-${row.faqId}`;
            });
          }
          success(adminFaqDetailsResult);
        });
    })
    .catch((e: any) => {
      error('getFaqDetails');
    });
};

export const createFAQ = async (
  account: AccountInfo,
  faq: Api.IFAQRequest,
  instance: IPublicClientApplication,
  success: Function,
  error: Function
) => {
  const request = {
    ...loginRequest,
    account: account,
  };
  instance
    .acquireTokenSilent(request)
    .then(async (response: any) => {
      var headers = new Headers();

      var bearer = 'Bearer ' + response.idToken;
      headers.append('Authorization', bearer);

      var bodyFormData = new FormData();
      bodyFormData.append('file', faq.file);
      bodyFormData.append('format', faq.format);
      bodyFormData.append('faqCategoryId', String(faq.faqCategoryId));
      bodyFormData.append('question', faq.question);
      bodyFormData.append('answer', faq.answer);
      bodyFormData.append('faqAudienceId', String(faq.faqAudienceId));
      bodyFormData.append('internalOnly', String(faq.internalOnly));
      bodyFormData.append('statusId', String(faq.statusId));
      bodyFormData.append('supportingLink', faq.supportingLink);
      bodyFormData.append('imageSupportingText', faq.imageSupportingText);
      bodyFormData.append('priority', faq.priority);
      bodyFormData.append('bucket', 'document-store');

      var options: any = {
        method: 'POST',
        headers: headers,
        body: bodyFormData,
      };

      const url = process.env.REACT_APP_API_SERVICES_URL;
      var createAdminFaqEndpoint = `${url}/documentmanagement/createfaq`;

      fetch(createAdminFaqEndpoint, options)
        .then(response => {
          if (response.status === 200) {
            return response.json();
          }
        })
        .then((createFaqResult: Common.IResult<Array<boolean>>) => {
          success(createFaqResult);
        });
    })
    .catch((e: any) => {
      error('createFaq');
    });
};

export const updateFAQ = async (
  account: AccountInfo,
  faq: Api.IFAQRequest,
  instance: IPublicClientApplication,
  success: Function,
  error: Function
) => {
  const request = {
    ...loginRequest,
    account: account,
  };
  instance
    .acquireTokenSilent(request)
    .then(async (response: any) => {
      var headers = new Headers();

      var bearer = 'Bearer ' + response.idToken;
      headers.append('Authorization', bearer);

      var bodyFormData = new FormData();

      bodyFormData.append('storageKey', faq.storageKey ? String(faq.storageKey) : '');
      bodyFormData.append('id', String(faq.id));

      bodyFormData.append('file', faq.file);
      bodyFormData.append('format', faq.format);

      bodyFormData.append('faqCategoryId', String(faq.faqCategoryId));

      bodyFormData.append('question', faq.question);
      bodyFormData.append('answer', faq.answer);

      bodyFormData.append('faqAudienceId', String(faq.faqAudienceId));
      bodyFormData.append('internalOnly', String(faq.internalOnly));

      bodyFormData.append('statusId', String(faq.statusId));

      bodyFormData.append('supportingLink', faq.supportingLink);
      bodyFormData.append('imageSupportingText', faq.imageSupportingText);

      bodyFormData.append('priority', faq.priority);
      bodyFormData.append('bucket', 'document-store');

      var options: any = {
        method: 'PUT',
        headers: headers,
        body: bodyFormData,
      };

      const url = process.env.REACT_APP_API_SERVICES_URL;
      var updateAdminFaqEndpoint = `${url}/documentmanagement/updatefaq`;

      fetch(updateAdminFaqEndpoint, options)
        .then(response => {
          if (response.status === 200) {
            return response.json();
          }
        })
        .then((updateFaqResult: Common.IResult<Array<boolean>>) => {
          success(updateFaqResult);
        });
    })
    .catch((e: any) => {
      error('updateFaq');
    });
};

export const publishFAQ = (
  account: AccountInfo,
  instance: IPublicClientApplication,
  id: number,
  success: Function,
  error: Function
) => {
  const request = {
    ...loginRequest,
    account: account,
  };

  instance
    .acquireTokenSilent(request)
    .then(async (response: any) => {
      var headers = new Headers();
      var bearer = 'Bearer ' + response.idToken;
      headers.append('Authorization', bearer);
      var options = {
        method: 'POST',
        headers: headers,
      };

      const url = process.env.REACT_APP_API_SERVICES_URL;
      const publishFaqEndpoint = `${url}/documentmanagement/publishfaq/${id}`;

      fetch(publishFaqEndpoint, options)
        .then(response => {
          if (response.status === 200) {
            return response.json();
          }
        })
        .then((publishFaqResult: Common.IResult<Array<boolean>>) => {
          success(publishFaqResult);
        });
    })
    .catch((e: any) => {
      error('publishfaq');
    });
};

export const deleteFAQ = (
  account: AccountInfo,
  instance: IPublicClientApplication,
  id: number,
  success: Function,
  error: Function
) => {
  const request = {
    ...loginRequest,
    account: account,
  };

  instance
    .acquireTokenSilent(request)
    .then(async (response: any) => {
      var headers = new Headers();
      var bearer = 'Bearer ' + response.idToken;
      headers.append('Authorization', bearer);
      var options = {
        method: 'DELETE',
        headers: headers,
      };

      const url = process.env.REACT_APP_API_SERVICES_URL;
      const deleteAdminFaqEndpoint = `${url}/documentmanagement/deleteFaq?id=${id}`; // TODO CHECK

      fetch(deleteAdminFaqEndpoint, options)
        .then(response => {
          if (response.status === 200) {
            return response.json();
          }
        })
        .then((deleteAdminFaqResult: Common.IResult<Array<boolean>>) => {
          success(deleteAdminFaqResult);
        });
    })
    .catch((e: any) => {
      error('deleteFaq');
    });
};

export const getFAQs = async (context: any) => {
  const url = process.env.REACT_APP_API_URL;
  const getFAQsEndpoint = `${url}/documentmanagement/getFAQs`;

  const headers = {};

  return await get(getFAQsEndpoint, { headers }, context);
};

export const getFAQsAdmin = (
  account: AccountInfo,
  instance: IPublicClientApplication,
  success: Function,
  error: Function
) => {
  const request = {
    ...loginRequest,
    account: account,
  };

  instance
    .acquireTokenSilent(request)
    .then(async (response: any) => {
      var headers = new Headers();
      var bearer = 'Bearer ' + response.idToken;
      headers.append('Authorization', bearer);
      var options = {
        method: 'GET',
        headers: headers,
      };

      const url = process.env.REACT_APP_API_SERVICES_URL;
      const currentAdminFaqsEndpoint = `${url}/documentmanagement/getFAQs`;

      fetch(currentAdminFaqsEndpoint, options)
        .then(response => {
          if (response.status === 200) {
            return response.json();
          }
        })
        .then((adminFaqsResult: Common.IResult<Array<any>>) => {
          success(adminFaqsResult);
        });
    })
    .catch((e: any) => {
      error('getFaqDetails');
    });
};

export const getFAQDocumentImageUrl = async (id: number, context: any, success: Function, error: Function) => {
  const url = process.env.REACT_APP_API_URL;
  const getFAQDocumentImageUrlEndpoint = `${url}/documentmanagement/files/${id}/image`;

  const token = context.getToken();
  const tokenHeaders = getHeaders(token);

  const headers = {
    Authorization: 'Bearer ' + tokenHeaders.token,
  };

  var options = {
    method: 'GET',
    headers: headers,
  };

  fetch(getFAQDocumentImageUrlEndpoint, options)
    .then(response => {
      if (response.status === 200) {
        return response.blob();
      } else {
        throw new Error('invalid request');
      }
    })
    .then((blob: any) => {
      success(blob);
    })
    .catch((e: any) => {
      error('getFAQDocumentImageUrl');
    });
};

export const getFAQDocumentImageUrlAdmin = (
  account: AccountInfo,
  instance: IPublicClientApplication,
  id: number,
  success: Function,
  error: Function
) => {
  const request = {
    ...loginRequest,
    account: account,
  };

  instance
    .acquireTokenSilent(request)
    .then(async (response: any) => {
      var headers = new Headers();
      var bearer = 'Bearer ' + response.idToken;
      headers.append('Authorization', bearer);

      var options: RequestInit = {
        cache: 'no-store',
        method: 'GET',
        headers: headers,
      };

      const url = process.env.REACT_APP_API_SERVICES_URL;
      const getFAQDocumentImageUrlEndpoint = `${url}/documentmanagement/files/${id}/image`;

      fetch(getFAQDocumentImageUrlEndpoint, options)
        .then(response => {
          if (response.status === 200) {
            return response.blob();
          } else {
            throw new Error('invalid request');
          }
        })
        .then((blob: any) => {
          success(blob);
        })
        .catch((e: any) => {
          error('getFAQDocumentImageUrl');
        });
    })
    .catch((e: any) => {
      error('getFAQDocumentImageUrl');
    });
};
